/* eslint-disable max-len */
import 'react';

const NoteTipSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="16" height="16" fill="white" />
        <mask id="mask0_209_291667" style={{'maskType': 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
            <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_209_291667)">
            <path d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z" stroke="#717886" />
            <path d="M8 7.32422V10.6903" stroke="#717886" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.66732 5.33268C8.66732 4.96449 8.36884 4.66602 8.00065 4.66602C7.63246 4.66602 7.33398 4.96449 7.33398 5.33268C7.33398 5.70087 7.63246 5.99935 8.00065 5.99935C8.36884 5.99935 8.66732 5.70087 8.66732 5.33268Z" fill="#717886" />
        </g>
    </svg>

);
export default NoteTipSvg;
